import {h, Fragment} from "preact"
import { useActions, useAppState } from '@nosto/preact'
import { defaultConfig } from '../config'
import { parseInteger } from '../helpers'
export default () => {
  const { query, response } = useAppState()
  const { updateSearch } = useActions()
  const from = parseInteger(query.products?.from)
  const size = parseInteger(response.products.size)
  const total = parseInteger(response.products.total)
  const to = from + size
  const currentPage = Math.ceil(from / size) + 1
  const totalPages = Math.ceil(total / size)
  const loadMore = () => {
    updateSearch({ products: { size: parseInteger(query.products.size) + parseInteger(defaultConfig.serpSize) }})
  }
  const getRelAttribute = () => {
    if (currentPage < totalPages) {
      return 'next'
    } else {
      return 'prev'
    }
  }
  // in reality we wont render the button if we are on the last page, so `prev` is never shown
  return (
    <div class="ns-load-more-container">
      {to < total && (
        <a
          class="ns-load-more-btn"
          href={`?page=${currentPage + 1}`}
          rel={getRelAttribute()}
          onClick={(e) => {
            e.preventDefault()
            loadMore()
          }}
        >
          Load More
        </a>
      )}
    </div>
  )
}